import React, { HTMLAttributes } from 'react'

import { cn } from '@frame/lib/utils/cn'

type Props = {
  letter: string
  className?: HTMLAttributes<HTMLDivElement>['className']
}

export function FallbackLetterImage({ letter, className }: Props) {
  return (
    <div
      className={cn(
        'flex h-[42px] w-[42px] shrink-0 items-center justify-center rounded-full bg-electric-200 pb-[0.5px] text-[24px] uppercase text-moss-950',
        className
      )}
      role="presentation"
      aria-hidden="true"
    >
      {letter}
    </div>
  )
}
